import ChallanBaseInput from "./ChallanBaseInput";

export default function ChallanTextInput({ ...rest }) {
  return <ChallanBaseInput type={"text"} {...rest} />;
}
